/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { DefaultButton, IButtonProps } from '@fluentui/react/lib/Button';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { LuisText } from 'src/core/components/LuisText';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getScopedTheme, getStylistV2 } from 'src/core/themes/luisStylist';
import { prettyPrintEntity } from 'src/luis/projects/entities/utils/entityHelpers';
import { ModelType } from 'src/luis/types/ModelType';

export type PredictedAsMenuItemProps = { entity: { name: string; typeId: ModelType } };

const theme = getScopedTheme('EntityDropdown');
const { styleComponent } = getStylistV2('EntityDropdown');

const StyledButton = styleComponent<IButtonProps>(DefaultButton)('StyledButton', {
    display: 'flex',
    backgroundColor: 'white',
    paddingLeft: '8px',
    height: 32
});

const messages = defineMessages({
    predictedAs: {
        id: 'labeling.entityDropdown.predictedAs',
        defaultMessage: 'Predicted as:'
    }
});

/**
 * Menu item that displays the predicted entity.
 */
export const PredictedAsMenuItem = ({ entity }: PredictedAsMenuItemProps) => {
    const { localize } = useLocalization();

    return (
        <StyledButton disabled>
            <LuisText color={theme.secondaryFontColor}>{localize(messages.predictedAs)}</LuisText>
            &nbsp;
            <LuisText color="black">{entity.name}</LuisText>
            &nbsp;
            <LuisText>({prettyPrintEntity(entity.typeId)})</LuisText>
        </StyledButton>
    );
};
